import React, { Component } from 'react';
import Carousel, {
  slidesToShowPlugin,
  slidesToScrollPlugin,
} from '@brainhubeu/react-carousel';
import '../styles/image-carousel.css';
import { isMobile } from 'react-device-detect';
import css from '../styles/about-the-project.scss';
import image1 from '../resources/esperanza.png';
import image2 from '../resources/cdtech.png';
import image3 from '../resources/usc.png';
import image4 from '../resources/communitycoalition.png';
import image5 from '../resources/scope.png';
import image6 from '../resources/trustsouthla.png';
import image7 from '../resources/saje.png';


const images = [image1, image2, image3, image4, image5, image6, image7];

let windowWidth;

class AboutCarousel extends Component {
  handleResize() {
    if (windowWidth != window.innerWidth) {
      location.reload();
      windowWidth = window.innerWidth;
    }
  }

  componentDidMount() {
    windowWidth = window.innerWidth;
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    if (isMobile) {
      return (
        <Carousel arrows infinite slidesPerPage={2}>
          {images.map(image => (
            <img key={image} src={`${image}`} className={css.sponsor} />
          ))}
        </Carousel>
      );
    }
    if (typeof window !== 'undefined' && window.innerWidth > 1200) {
      return (
        <Carousel arrows infinite slidesPerPage={3}>
          {images.map(image => (
            <img key={image} src={`${image}`} className={css.sponsor} />
          ))}
        </Carousel>
      );
    }
    if (typeof window !== 'undefined' && window.innerWidth > 900) {
      return (
        <Carousel arrows infinite slidesPerPage={2}>
          {images.map(image => (
            <img key={image} src={`${image}`} className={css.sponsor} />
          ))}
        </Carousel>
      );
    }

    return (
      <Carousel arrows infinite slidesPerPage={1}>
        {images.map(image => (
          <img key={image} src={`${image}`} className={css.sponsor} />
        ))}
      </Carousel>
    );
  }
}

export default AboutCarousel;
